<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense color="#96298A" dark>
        <v-toolbar-title>Reporte Compras Línea</v-toolbar-title>
        <v-divider class="mx-4" vertical></v-divider>
        <v-btn color="#FC8333" text outlined @click="showParams = !showParams">
          <div v-if="!showParams">
            Ver Parametros <v-icon>mdi-arrow-right</v-icon>
          </div>
          <div v-else>Ocultar Parametros <v-icon>mdi-arrow-left</v-icon></div>
        </v-btn>
        <v-divider class="mx-4" vertical></v-divider>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-divider class="mx-4" vertical></v-divider>
          <v-text-field
            v-model="searcher"
            append-icon="mdi-file-search"
            label="Buscar"
            single-line
            hide-details
            clearable
            max-width="200px"
          ></v-text-field>
          <v-divider vertical class="mx-4"></v-divider>
          <v-select
            v-model="selectedHeaders"
            label="Campos del Reporte"
            :items="headers"
            append-icon="mdi-format-columns"
            return-object
            clearable
            filled
            multiple
          >
            <template v-slot:selection="{ item, index }">
              <v-chip
                v-if="index < 2"
                x-small
                color="#FC8333"
                text-color="black"
              >
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 2" class="grey--text caption"
                >(+{{ selectedHeaders.length - 2 }} otros)</span
              >
            </template>
          </v-select>
          <v-divider class="mx-4" vertical></v-divider>
          <v-btn icon x-large @click="exportToExcel()"
            ><v-icon>mdi-microsoft-excel</v-icon></v-btn
          >
          <v-divider class="mx-4" vertical></v-divider>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="3" v-if="showParams">
            <v-card>
              <v-card-subtitle>Parametros</v-card-subtitle>
              <v-card-text>
                <v-row dense>
                  <v-radio-group
                    row
                    label="Fecha de Reporte:"
                    v-model="fechaRep"
                  >
                    <v-radio :value="0" label="Creación"></v-radio>
                    <v-radio :value="1" label="Arribo"></v-radio>
                    <v-radio :value="2" label="Liberacion Aduana"></v-radio>
                    <v-radio :value="3" label="Entregado"></v-radio>
                  </v-radio-group>
                </v-row>
                <v-row dense>
                  <v-col>
                    <v-text-field
                      v-model="desde"
                      type="date"
                      clearable
                      label="Desde"
                    ></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="hasta"
                      type="date"
                      clearable
                      label="Hasta"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col v-show="isCliente == 0">
                    <v-combobox
                      v-model="cliente"
                      label="Cliente"
                      :items="clientes"
                      item-value="cliente"
                      item-text="cliente"
                      return-object
                      clearable
                    />
                  </v-col>
                  <v-col>
                    <v-combobox
                      v-model="vuelo"
                      label="Vuelo"
                      :items="vuelos"
                      item-value="no_vuelo"
                      item-text="no_vuelo"
                      return-object
                      clearable
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col>
                    <v-combobox
                      v-model="provincia"
                      :items="provincias"
                      item-text="provincia"
                      item-value="provincia"
                      label="Provincia"
                      return-object
                      clearable
                    ></v-combobox>
                  </v-col>
                  <v-col>
                    <v-combobox
                      v-model="ciudad"
                      :items="ciudades"
                      item-text="ciudad"
                      item-value="ciudad"
                      label="Ciudad"
                      return-object
                      clearable
                    ></v-combobox>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col>
                    <v-combobox
                      label="Depot"
                      :items="depots"
                      v-model="depot"
                      item-text="depot"
                      item-value="depot"
                      return-object
                      clearable
                    ></v-combobox>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col>
                    <v-combobox
                      v-model="estatus"
                      label="Estatus"
                      :items="estatuses"
                      append-icon="mdi-sticker-check"
                      item-value="id"
                      item-text="descripcion"
                      return-object
                      clearable
                    ></v-combobox>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col>
                    <v-combobox
                      v-model="pendfin"
                      label="Pendientes / Finalizadas"
                      :items="pendfines"
                      append-icon="mdi-playlist-check"
                      item-value="cod"
                      item-text="descripcion"
                      return-object
                      clearable
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark outlined @click="getData()"
                  >Generar <v-icon>mdi-file</v-icon></v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" :md="showParams ? '9' : '12'">
            <v-card>
              <v-card-subtitle>Reporte</v-card-subtitle>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-data-table
                      :headers="showHeaders"
                      :items="guias"
                      :search="searcher"
                    >
                      <template v-slot:item.proceso="{ item }">
                        <span v-if="item.proceso == 1">Si</span>
                        <span v-if="item.proceso == 0">No</span>
                      </template>
                      <template v-slot:item.no_controlado="{ item }">
                        <span v-if="item.no_controlado == 1">Si</span>
                        <span v-if="item.no_controlado == 0">No</span>
                      </template>
                      <template v-slot:item.fecha_estatus="{ item }">
                        {{
                          item.ultimoestatus != null
                            ? formatDate(
                                item.ultimoestatus.fecha + 'T00:00:00Z'
                              )
                            : null
                        }}
                      </template>
                      <template v-slot:item.ultimo_estatus="{ item }">
                        {{
                          item.ultimoestatus != null
                            ? item.ultimoestatus.estatus.descripcion
                            : null
                        }}
                      </template>
                      <template v-slot:item.comentario_estatus="{ item }">
                        {{
                          item.ultimoestatus != null
                            ? item.ultimoestatus.comentarios
                            : null
                        }}
                      </template>
                      <template v-slot:item.envios_ruta="{ item }">
                        {{
                          item.conteoruta
                        }}
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </v-container>
</template>

  <script>
import Waiting from '../components/Waiting.vue';
import apicon from "../plugins/apicon";
import utils from "../utils/utils";
const XLSX = require("xlsx");
export default {
  created: function () {},
  components:{
    Waiting
  },
  data() {
    return {
      showParams: true,
      desde: null,
      hasta: null,
      searcher: null,
      clientes: [],
      cliente: null,
      fechaRep: 0,
      guias: [],
      headers: [
        { text: "Cliente", value: "cliente", sortable: false },
        { text: "Fecha Arribo", value: "fecha_arribo", sortable: false },
        { text: "Guia Master", value: "guia_master", sortable: false },
        { text: "Guia Hija", value: "guia_hija", sortable: false },
        { text: "Shipper", value: "shipper", sortable: false },
        { text: "Destinatario", value: "destinatario", sortable: false },
        { text: "Cedula", value: "cedula", sortable: false },
        { text: "Direccion", value: "direccion", sortable: false },
        { text: "Valor", value: "valor", sortable: false },
        { text: "No Articulos", value: "no_articulos", sortable: false },
        { text: "Descripcion", value: "descripcion", sortable: false },
        { text: "Provincia", value: "provincia", sortable: false },
        { text: "Ciudad", value: "ciudad", sortable: false },
        { text: "Cod Postal", value: "cod_postal", sortable: false },
        { text: "Telefono", value: "telefono", sortable: false },
        { text: "Bultos", value: "bultos", sortable: false },
        { text: "Peso (kg)", value: "peso_kg", sortable: false },
        { text: "Larco (cm)", value: "largo_cm", sortable: false },
        { text: "Ancho (cm)", value: "ancho_cm", sortable: false },
        { text: "Alto (cm)", value: "alto_cm", sortable: false },
        { text: "Remitente", value: "remitente", sortable: false },
        {
          text: "Dirección Remitente",
          value: "direccion_remitente",
          sortable: false,
        },
        { text: "Ciudad Origen", value: "ciudad_origen", sortable: false },
        { text: "ETD", value: "etd", sortable: false },
        { text: "ETA", value: "eta", sortable: false },
        { text: "No Vuelo", value: "no_vuelo", sortable: false },
        { text: "Estatus", value: "ultimo_estatus", sortable: false },
        { text: "Fecha Estatus", value: "fecha_estatus", sortable: false },
        {
          text: "Comentario Estatus",
          value: "comentario_estatus",
          sortable: false,
        },
        {
          text: "Envios a Ruta",
          value: "envios_ruta",
          sortable: false,
        },
        { text: "Entregado a", value: "pod_nombre", sortable: false },
        { text: "DNI", value: "pod_dni", sortable: false },
        { text: "Fecha Entregado", value: "pod_fecha", sortable: false },
        { text: "Hora Entregado", value: "pod_hora", sortable: false },
        { text: "referencia 1", value: "referencia1", sortable: false },
        { text: "referencia 2", value: "referencia2", sortable: false },
        { text: "referencia 3", value: "referencia3", sortable: false },
        { text: "Operador", value: "operador", sortable: false },
        { text: "Depot", value: "depot", sortable: false },
        { text: "Guia Agente", value: "guia_agente", sortable: false },
        {
          text: "fecha_liberacion",
          value: "fecha_liberacion",
          sortable: false,
        },
        { text: "Proceso", value: "proceso", sortable: false },
        { text: "Agente", value: "agente.nombre", sortable: false },
        { text: "Tiempo Transito", value: "tiempo_transito", sortable: false },
        { text: "No Controlado", value: "no_controlado", sortable: false },
        { text: "Observacion", value: "observacion", sortable: false },
        {
          text: "Fecha Estimada Vuelo",
          value: "fecha_estimada_vuelo",
          sortable: false,
        },
        {
          text: "Fecha Declaracion",
          value: "fecha_declaracion",
          sortable: false,
        },
        {
          text: "Dias Habiles Declaracion",
          value: "dias_habiles_declaracion",
          sortable: false,
        },
        {
          text: "Dias Habiles Liberacion",
          value: "dias_habiles_liberacion",
          sortable: false,
        },
        { text: "Tipo Aforo", value: "tipo_aforo", sortable: false },
        { text: "Refrendo", value: "refrendo", sortable: false },
        { text: "MRN", value: "mrn", sortable: false },
        { text: "MSN", value: "msn", sortable: false },
        { text: "HSN", value: "hsn", sortable: false },
        { text: "Valor Declarado", value: "valor_declarado", sortable: false },
        {
          text: "Peso Ingresado Aduana",
          value: "peso_ingresado_aduana",
          sortable: false,
        },
        { text: "Categoria", value: "categoria", sortable: false },
        { text: "Causa Abandono", value: "causa_abandono", sortable: false },
        { text: "Estatus Aduana", value: "estatus_aduana", sortable: false },
        {
          text: "Novedad Inexpress",
          value: "novedad_inexpress",
          sortable: false,
        },
      ],
      headersCli:[
        { text: "Cliente", value: "cliente", sortable: false },
        { text: "Fecha Arribo", value: "fecha_arribo", sortable: false },
        { text: "Guia Hija", value: "guia_hija", sortable: false },
        { text: "Shipper", value: "shipper", sortable: false },
        { text: "Destinatario", value: "destinatario", sortable: false },
        { text: "Cedula", value: "cedula", sortable: false },
        { text: "Direccion", value: "direccion", sortable: false },
        { text: "Valor", value: "valor", sortable: false },
        { text: "No Articulos", value: "no_articulos", sortable: false },
        { text: "Descripcion", value: "descripcion", sortable: false },
        { text: "Provincia", value: "provincia", sortable: false },
        { text: "Ciudad", value: "ciudad", sortable: false },
        { text: "Cod Postal", value: "cod_postal", sortable: false },
        { text: "Telefono", value: "telefono", sortable: false },
        { text: "Bultos", value: "bultos", sortable: false },
        { text: "Peso (kg)", value: "peso_kg", sortable: false },
        { text: "Estatus", value: "ultimo_estatus", sortable: false },
        { text: "Fecha Estatus", value: "fecha_estatus", sortable: false },
        {
          text: "Comentario Estatus",
          value: "comentario_estatus",
          sortable: false,
        },
        {
          text: "Envios a Ruta",
          value: "envios_ruta",
          sortable: false,
        },
        { text: "Entregado a", value: "pod_nombre", sortable: false },
        { text: "Fecha Entregado", value: "pod_fecha", sortable: false },
        { text: "Hora Entregado", value: "pod_hora", sortable: false },
        { text: "Guia Agente", value: "guia_agente", sortable: false },
        {
          text: "fecha_liberacion",
          value: "fecha_liberacion",
          sortable: false,
        },
        { text: "Agente", value: "agente.nombre", sortable: false },
        { text: "Tipo Aforo", value: "tipo_aforo", sortable: false },
      ],
      selectedHeaders: [],
      isCliente: false,
      vuelos: [],
      vuelo: null,
      provincias: [],
      ciudades: [],
      provincia: null,
      ciudad: null,
      depots: [{ depot: "GYE" }, { depot: "UIO" }, { depot: "ECO" }],
      depot: null,
      estatus: null,
      estatuses: [],
      pendfin: null,
      pendfines: [
          {descripcion: 'Pendientes', cod: 'P'},
          {descripcion: 'Entregados', cod: 'E'},
      ],
      overlay: false,
    };
  },
  watch: {
    provincia: function (item) {
      if (item) {
        this.ciudad = null;
        this.fillCiudades(item.provincia);
      }
    },
  },
  methods: {
    getEstatuses: function(){
        apicon.getDataApi(apicon.getApiBaseUrl() + 'estatusall').then((result) => {
            this.estatuses = result
        }).catch((err) => {
            console.log(err);
        })
    },
    getData:async function () {
      this.overlay = true;
      await apicon
        .saveDataApi(apicon.getApiBaseUrl() + "reportegeneralcl", {
          fechaRep: this.fechaRep,
          desde: this.desde,
          hasta: this.hasta,
          cliente: this.cliente != null ? this.cliente.cliente : null,
          no_vuelo: this.vuelo != null ? this.vuelo.no_vuelo : null,
          provincia: this.provincia != null ? this.provincia.provincia : null,
          ciudad: this.ciudad != null ? this.ciudad.ciudad : null,
          depot: this.depot != null ? this.depot.depot : null,
          estatus: this.estatus != null ? this.estatus.id : null,
          pendfin: this.pendfin != null ? this.pendfin.cod : null,
        })
        .then((result) => {
          this.overlay = false
          this.guias = result;
          this.showParams = false;
        })
        .catch((err) => {
          this.overlay = false;
          console.log(err);
        });
    },
    getClientes: function () {
      apicon
        .getDataApi(apicon.getApiBaseUrl() + "getclientescl")
        .then((result) => {
          this.clientes = result;
        });
    },
    getVuelos: function () {
      apicon
        .getDataApi(apicon.getApiBaseUrl() + "getvueloscl")
        .then((result) => {
          this.vuelos = result;
        });
    },
    formatDate: function (date) {
      return utils.formatDate(date);
    },
    exportToExcel: function () {
      //Map Data to new Json
      let newJson = this.guias.map((rec) => {
        let obj =  {
          Cliente: rec.cliente,
          "Fecha Arribo": rec.fecha_arribo,
          "Guia Master": rec.guia_master,
          "Guia Hija": rec.guia_hija,
          Shipper: rec.shipper,
          Destinatario: rec.destinatario,
          Cedula: rec.cedula,
          Direccion: rec.direccion,
          Valor: rec.valor,
          "No Articulos": rec.no_articulos,
          Descripcion: rec.descripcion,
          Provincia: rec.provincia,
          Ciudad: rec.ciudad,
          "Cod Postal": rec.cod_postal,
          Telefono: rec.telefono,
          Bultos: rec.bultos,
          "Peso (kg)": rec.peso_kg,
          "Larco (cm)": rec.largo_cm,
          "Ancho (cm)": rec.ancho_cm,
          "Alto (cm)": rec.alto_cm,
          Remitente: rec.remitente,
          "Dirección Remitente": rec.direccion_remitente,
          "Ciudad Origen": rec.ciudad_origen,
          ETD: rec.etd,
          ETA: rec.eta,
          "No Vuelo": rec.no_vuelo,
          Estatus: rec.ultimoestatus != null
                            ? rec.ultimoestatus.estatus.descripcion
                            : null,
          "Fecha Estatus":
                          rec.ultimoestatus != null
                            ?
                            this.formatDate(rec.ultimoestatus.fecha + 'T00:00:00Z')
                            : null
                        ,
          "Comentario Estatus":  rec.ultimoestatus != null
                            ? rec.ultimoestatus.comentarios
                            : null,
          "Envios a Ruta": rec.conteoruta,
          "Entregado a": rec.pod_nombre,
          DNI: rec.pod_dni,
          "Fecha Entregado": rec.pod_fecha,
          "Hora Entregado": rec.pod_hora,
          "referencia 1": rec.referencia1,
          "referencia 2": rec.referencia2,
          "referencia 3": rec.referencia3,
          Operador: rec.operador,
          Depot: rec.depot,
          "Guia Agente": rec.guia_agente,
          fecha_liberacion: rec.fecha_liberacion,
          Proceso:
            rec.proceso != null ? (rec.proceso == 1 ? "Si" : "No") : null,
          Agente: rec.agente != null ? rec.agente.nombre : null,
          "Tiempo Transito": rec.tiempo_transito,
          "No Controlado":
            rec.no_controlado != null
              ? rec.no_controlado == 1
                ? "Si"
                : "No"
              : null,
          Observacion: rec.observacion,
          "Fecha Estimada Vuelo": rec.fecha_estimada_vuelo,
          "Fecha Declaracion": rec.fecha_declaracion,
          "Dias Habiles Declaracion": rec.dias_habiles_declaracion,
          "Dias Habiles Liberacion": rec.dias_habiles_liberacion,
          "Tipo Aforo": rec.tipo_aforo,
          Refrendo: rec.refrendo,
          MRN: rec.mrn,
          MSN: rec.msn,
          HSN: rec.hsn,
          "Valor Declarado": rec.valor_declarado,
          "Peso Ingresado Aduana": rec.peso_ingresado_aduana,
          Categoria: rec.categoria,
          "Causa Abandono": rec.causa_abandono,
          "Estatus Aduana": rec.estatus_aduana,
          "Novedad Inexpress": rec.novedad_inexpress,
        };
        //Eliminar las columnas no seleccionadas
        Object.keys(obj).forEach((key) => {
          const found = this.selectedHeaders.some((el) => el.text === key);
          if (!found) {
            delete obj[key];
          }
        });
        return obj;
      });
      let data = XLSX.utils.json_to_sheet(newJson);
      const workbook = XLSX.utils.book_new();
      const filename = "Reporte Compras Linea";
      //Fit columns
      const wscols = utils.getAutoFitColumns(newJson);
      data["!cols"] = wscols;

      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    fillProvincias: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "provinciasec")
        .then((result) => {
          this.provincias = result;
        });
    },
    fillCiudades: async function (provincia) {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "ciudadesec/" + provincia)
        .then((result) => {
          this.ciudades = result;
        });
    },
  },
  computed: {
    showHeaders() {
      return this.headers.filter((s) => this.selectedHeaders.includes(s));
    },
  },
  mounted: async function () {
    apicon.setAuthHeaders();
    this.getEstatuses();
    this.isCliente = localStorage.getItem("cliente");
    //verificar los headers del reporte
    if(this.isCliente == 1){
      this.headers = await this.headersCli;
    }
    this.selectedHeaders = this.headers;
    this.getClientes();
    this.getVuelos();
    this.fillProvincias();
  },
};
</script>
